var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`cc-iconfont i-clouddm icon-${_vm.name}`,style:(_vm.styleVar)})
}
var staticRenderFns = []

export { render, staticRenderFns }